import stickCommon from 'site/stickCommon'
/*
{
            file:'01 - Theme from Glass Onion_1.mp3',
            name:'Theme from Glass Onion'
        },
        {
            file:'02 - The Puzzle Box_1.mp3',
            name:'The Puzzle Box'
        },
        {
            file:'03 - Andis Theme_1.mp3',
            name:"Andi's Theme"
        },
        {
            file:'04 - An Anonymous Invitation_1.mp3',
            name:'An Anonymous Invitation'
        },
        {
            file:'05 - Ground Rules_1.mp3',
            name:'Ground Rules'
        },
        {
            file:'06 - Ms. Birdie Jay_1.mp3',
            name:'Ms. Birdie Jay'
        },
        {
            file:'07 - The Infraction Point_1.mp3',
            name:'The Infraction Point'
        },
        {
            file:'08 - Dinner is Served_1.mp3',
            name:'Dinner is Served'
        },
        {
            file:'09 - This is Not a Game_1.mp3',
            name:'This is Not a Game'
        },
        {
            file:'10 - The Scene of the Crime_1.mp3',
            name:'The Scene of the Crime'
        },
        {
            file:'11 - Trapped_1.mp3',
            name:'Trapped'
        },
        {
            file:'12 - Lights Out!_1.mp3',
            name:'Lights Out!'
        },
        {
            file:'13 - Time to Finish This_1.mp3',
            name:'Time to Finish This'
        },
        {
            file:'14 - Blancs Plan_1.mp3',
            name:"Blanc's Plan"
        },
        {
            file:'15 - Snoop_1.mp3',
            name:'Snoop'
        },
        {
            file:'16 - Motive & Opportunity_1.mp3',
            name:'Motive & Opportunity'
        },
        {
            file:'17 - Somethings Off_1.mp3',
            name:"Something's Off"
        },
        {
            file:'18 - Perjury_1.mp3',
            name:'Perjury'
        },
        {
            file:'19 - Ransacking_1.mp3',
            name:'Ransacking'
        },
        {
            file:'20 - A.B-.mp3',
            name:'A.B'
        },
        {
            file:'21 - The Center of the Onion_1.mp3',
            name:'The Center of the Onion'
        },
        {
            file:'22 - Peeled Back_1.mp3',
            name:'Peeled Back'
        },
        {
            file:'23 - Youve Got Nothing_1.mp3',
            name:"You've Got Nothing"
        },
        {
            file:'24 - Glass Onion String Quartet in Bb Minor_1.mp3',
            name:'Glass Onion String Quartet in Bb Minor'
        },
        {
            file:'25 - Burnt_1.mp3',
            name:'Burnt'
        },
        {
            file:'26 - Disruption_1.mp3',
            name:'Disruption'
        },
        {
            file:'27 - Theme from Glass Onion - Revisited_1.mp3',
            name:'Theme from Glass Onion - Revisited'
        },
 */
let audioPlayer = {
    isOpen:false,
    isPlaying:false,
    scrubberWidth:175,
    dotDragShift:-3,

    wasPlaying:false,
    autoplayPauseCount:0,

    mp3:null,
    seektime:0,
    currentTrack:0,
    tracks:[
        {
            file:'01 - Theme from Glass Onion_1.mp3',
            name:'Theme from Glass Onion'
        },
        {
            file:'04 - An Anonymous Invitation_1.mp3',
            name:'An Anonymous Invitation'
        },
    ],
    init:function () {
        $('#audio-close').click(audioPlayer.close)
        $('#audio-opener').click(audioPlayer.open)
        $('#audio-opener').on('mouseenter', audioPlayer.audioOpenerOver)
        $('#audio-opener').on('mouseleave', audioPlayer.audioOpenerOut)
        $('#audio-volume').click(audioPlayer.playPauseToggle)
        $('#audio-prev').click(audioPlayer.prevFile)
        $('#audio-next').click(audioPlayer.nextFile)
        $('#audio-playPause').click(audioPlayer.playPauseToggle)


        $( "#audio-scrubber .drag-hook" ).draggable({
            axis: "x",
            containment: "parent",
            cursor: 'move',
            drag: function(event,ui){
                if (typeof(audioPlayer.mp3) !== 'undefined' && audioPlayer.mp3 !== null) {
                    $('#audio-scrubber .drag-hook').removeClass('notdragged')
                    audioPlayer.pause()
                    return true
                } else {
                    return false
                }
            },
            stop: function( event, ui ) {
                if (typeof(audioPlayer.mp3) !== 'undefined' && audioPlayer.mp3 !== null) {
                    var maxw = audioPlayer.scrubberWidth
                    var thex = stickCommon.pxToNum($('#audio-scrubber .drag-hook').css('left'))
                    var pct = thex / maxw
                    $('#audio-scrubber .drag-hook').addClass('notdragged')
                    audioPlayer.jumpToPct(pct)
                }
            }
        })




        //init scrubber, track name
        audioPlayer.currentTrack = 0
        $('#audio-scrubber .drag-hook').css('left', audioPlayer.dotDragShift + 'px')

        audioPlayer.setTrackName()


        $(window).on("resize", audioPlayer.resize)
        audioPlayer.resize()



    },//init

    openToggle() {
        if (audioPlayer.isOpen) {
            audioPlayer.close()
        } else {
            audioPlayer.open()
        }
    },

    audioOpenerOver: function () {
        $('#audio').addClass('openHover')
    },
    audioOpenerOut: function () {
        $('#audio').removeClass('openHover')
    },

    playPauseToggle() {
        if (audioPlayer.isPlaying) {
            audioPlayer.pause()
        } else {
            audioPlayer.play()
        }
    },

    pause() {
        $('#audio').addClass('muted')
        $('#audio').removeClass('unmuted')
        audioPlayer.isPlaying=false

        if (typeof(audioPlayer.mp3) !== 'undefined' && audioPlayer.mp3 !== null) {
            try {
                audioPlayer.mp3.pause()
            } catch (e) {}

        }
    },
    play(doOpen= false) {
        if (doOpen) {
            audioPlayer.open()
        }

        $('#audio').removeClass('muted')
        $('#audio').addClass('unmuted')
        audioPlayer.isPlaying=true


        if (typeof(audioPlayer.mp3) !== 'undefined' && audioPlayer.mp3 !== null) {
            try {
                audioPlayer.mp3.play()
            } catch (e) {}
        } else {
            audioPlayer.loadFileAndPlay()
        }
    },

    open() {
        $('#audio').addClass('open')
        $('#audio-close').addClass('open')
        audioPlayer.isOpen=true
    },
    close() {
        $('#audio').removeClass('open')
        $('#audio-close').removeClass('open')
        audioPlayer.isOpen=false
    },


    prevFile() {
        audioPlayer.currentTrack--
        if (audioPlayer.currentTrack<0) {
            audioPlayer.currentTrack = audioPlayer.tracks.length-1
        }
        audioPlayer.loadFileAndPlay()
    },
    nextFile() {
        audioPlayer.currentTrack++
        if (audioPlayer.currentTrack >= audioPlayer.tracks.length) {
            audioPlayer.currentTrack =  0
        }
        audioPlayer.loadFileAndPlay()
    },
    loadFileAndPlay() {
        if (typeof(audioPlayer.mp3) !== 'undefined' && audioPlayer.mp3 !== null) {
            audioPlayer.mp3.removeEventListener("ended", audioPlayer.soundEnded)
            audioPlayer.mp3.removeEventListener("timeupdate", audioPlayer.soundUpdate)
            audioPlayer.pause()
            audioPlayer.mp3.currentTime = 0
        }
        let track = audioPlayer.tracks[audioPlayer.currentTrack]
        let finalMp3Name = basePath + 'assets/site/mp3/' + track.file
        audioPlayer.mp3 = new Audio(finalMp3Name)
        audioPlayer.mp3.addEventListener("ended", audioPlayer.soundEnded)
        audioPlayer.mp3.addEventListener("timeupdate", audioPlayer.soundUpdate)
        audioPlayer.play()

        audioPlayer.setTrackName()
    },

    setTrackName() {
        let track = audioPlayer.tracks[audioPlayer.currentTrack]
        //let trackDisplayName = track.name + ' - Song ' + (audioPlayer.currentTrack + 1)
        let trackDisplayName = track.name
        $('#audio-trackName').html(trackDisplayName)
    },

    soundEnded() {
        audioPlayer.nextFile()
    },
    soundUpdate:function() {
        if (audioPlayer.mp3) {
            var disp_ct,disp_duration,pct;
            var ogpct = audioPlayer.mp3.currentTime/audioPlayer.mp3.duration;
            if (audioPlayer.mp3.currentTime>0) {
                disp_ct = stickCommon.toHHMMSS(audioPlayer.mp3.currentTime);
                disp_duration = stickCommon.toHHMMSS(audioPlayer.mp3.duration);
                pct = 100*ogpct;
            } else {
                disp_ct="";
                disp_duration="";
                pct = 0;
            }
            $('#audio-currentTime').html(disp_ct);
            $('#audio-totalTime').html(disp_duration);
            $('#audio-scrubber .fill').css('width',pct+"%");
            //$('#audio-scrubber .dot').css('width',pct+"%");
            //$('#scrubbar-dot').css('left',pct+"%");

            var maxw = audioPlayer.scrubberWidth
            var thex = ogpct * maxw + audioPlayer.dotDragShift
            $('#audio-scrubber .drag-hook').css('left',thex+"px");
        }

    },

    jumpToPct:function(pct) {
        //chrome does NOT seek local host - try safari
        audioPlayer.seektime = parseFloat(audioPlayer.mp3.duration * pct);
        audioPlayer.mp3.currentTime = audioPlayer.seektime
        audioPlayer.mp3.addEventListener("playing", audioPlayer.soundPlaying)
        audioPlayer.play()
    },
    soundPlaying:function() {
        audioPlayer.mp3.removeEventListener("playing", audioPlayer.soundPlaying);
        audioPlayer.mp3.currentTime = audioPlayer.seektime;
    },


    pauseOnVideoPlay() {
        audioPlayer.autoplayPauseCount++
        if (audioPlayer.autoplayPauseCount<=1) {
            audioPlayer.wasPlaying = audioPlayer.isPlaying
        }
        audioPlayer.pause()
    },
    resumeOnVideoPlay() {

        audioPlayer.autoplayPauseCount--
        if (audioPlayer.autoplayPauseCount<0) {
            audioPlayer.autoplayPauseCount=0
        }

        if (audioPlayer.autoplayPauseCount === 0 && audioPlayer.wasPlaying) {
            audioPlayer.play()
        }
    },

    resize: function () {
        let sw = $(window).width()
        let mobileSize = 650
        let neww = 330
        audioPlayer.scrubberWidth = 175
        if (sw < mobileSize) {
            neww = sw - 40 // 40 is padding on each sides
        }
        let translatex = (neww - 55) * -1  //-275
        let clippath = neww - 58  //272
        let main2w = neww - 54  //276
        audioPlayer.scrubberWidth = neww - 155  //175

        //clip-path: polygon(272px 0, 100% 0, 100% 100%, 272px 100%);
        document.documentElement.style.setProperty('--restingClipPath', 'polygon(' + clippath + 'px 0, 100% 0, 100% 100%, ' + clippath + 'px 100%)')
        $('#audio').css(
            {
                width:neww,
                transform: 'translateX(' + translatex + 'px)'
            }
        )
        $('#audio-main2').css(
            {
                width:main2w
            }
        )
        $('#audio-scrubber').css('width', audioPlayer.scrubberWidth+'px')
    }



}; //obj
export default audioPlayer
